import axios from 'axios'
import { baseUrl, API_KEY, MOCK_MODE } from './constants/constants'
import { mockCategories } from './constants/mockData'

const instance = axios.create({
    baseURL: baseUrl,
});

// Interceptor for Mock Mode
instance.interceptors.request.use((config) => {
    if (MOCK_MODE && !API_KEY) {
        // Return a mock response if API Key is missing and MOCK_MODE is enabled
        const url = config.url || "";
        let data = [];

        if (url.includes('trending')) data = mockCategories.trending;
        else if (url.includes('discover/tv')) data = mockCategories.originals;
        else if (url.includes('with_genres=28')) data = mockCategories.action;
        else if (url.includes('with_genres=35')) data = mockCategories.comedy;
        else if (url.includes('with_genres=27')) data = mockCategories.horror;
        else if (url.includes('with_genres=10749')) data = mockCategories.romance;
        else if (url.includes('with_genres=99')) data = mockCategories.documentary;
        else if (url.includes('/videos')) data = [{ key: "dQw4w9WgXcQ" }]; // Mock trailer key (Rickroll)
        else data = mockCategories.trending; // Default

        // Throw an object that the components can catch as a "fake" successful response
        // Or better, let's just make the components aware or use a simpler approach.
        // Actually, returning a Promise that resolves with data is better.
        return Promise.reject({
            config,
            isMockData: true,
            mockResponse: { data: { results: data } }
        });
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default instance
